define.alias("ember-composable-helpers/helpers/group-by", "settings/helpers/group-by");